import { useEffect, useState } from 'react';
import { auditTrailApi } from '@/services/auditTrailApi';
import { getApiErrorStatus } from '@/services/reportPaging';
import type { AuditTrailDetail, AuditTrailRow } from '@/utils/AuditTrail/types';
import { mapHistoryToDetail } from '@/utils/AuditTrail/mappers';

export function useAuditTrailHistory(row: AuditTrailRow | null, open: boolean) {
  const [history, setHistory] = useState<AuditTrailDetail | null>(null);
  const [historyError, setHistoryError] = useState<string | null>(null);

  useEffect(() => {
    if (!row || !open) return;
    let cancelled = false;
    setHistory(null);
    setHistoryError(null);
    auditTrailApi
      .getHistory(row.timesheetId)
      .then((result) => {
        if (!cancelled) setHistory(mapHistoryToDetail(result, row));
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setHistoryError(
          getApiErrorStatus(err) === 404
            ? 'No workflow history has been recorded for this timesheet.'
            : 'Unable to load the history for this timesheet.',
        );
      });
    return () => { cancelled = true; };
  }, [row, open]);

  return { history, historyError };
}
